import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle
} from 'react'
import { TextField } from 'material-ui'

if (process.env.WEBPACK) {
  require('./TransferWallet.css')
}
const DialogContent = forwardRef((props, ref) => {
  const { handleTransferWalletFormDataChange } = props
  const [destinationAccountNumber, setDestinationAccountNumber] = useState('')
  const [transferReason, setTransferReason] = useState('')
  const [errors, setErrors] = useState({})

  useEffect(() => {
    handleTransferWalletFormDataChange({
      destinationAccountNumber,
      transferReason
    })
  }, [destinationAccountNumber, transferReason])

  useImperativeHandle(ref, () => ({
    validateForm() {
      const newErrors = {}
      let isValid = true

      if (!destinationAccountNumber) {
        newErrors.destinationAccountNumber =
          'Destination Account Number is required'
        isValid = false
      }
      if (!transferReason) {
        newErrors.transferReason = 'Reason for transfer is required'
        isValid = false
      }

      setErrors(newErrors)
      return isValid
    }
  }))

  return (
    <div className='form-container'>
      <TextField
        floatingLabelText='Destination Account Number'
        type='number'
        value={destinationAccountNumber}
        onChange={e => {
          const value = e.target.value
          if (value.length <= 10 && value <= 1000000000)
            setDestinationAccountNumber(e.target.value)
          setErrors({})
        }}
        errorText={errors.destinationAccountNumber}
      />
      <TextField
        floatingLabelText='Reason For Transfer'
        type='text'
        value={transferReason}
        onChange={e => {
          if (e.target.value.length <= 250) setTransferReason(e.target.value)
          setErrors({})
        }}
        errorText={errors.transferReason}
      />
    </div>
  )
})

export default DialogContent



/** WEBPACK FOOTER **
 ** ./src/containers/TransferWallet/DialogContent.js
 **/